import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import OrderRowProductCard from '../OrderRowProductCard/OrderRowProductCard';
import CheckoutSection from './utils/Checkout.Section';
import CheckoutSectionContent from './utils/Checkout.SectionContent';
import CheckoutSectionFooter from './utils/Checkout.SectionFooter';
import { translate } from '../../Services/translation';
import CheckoutOrderSummary from './Checkout.OrderSummary';
import Discount from './Checkout.Discount';
import { update } from '../../Actions/Cart.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import clsx from 'clsx';
import Icon from '../Icon';
import { OrderRow } from '../../Types/OrderRow';
import { trackingServiceInitiateCheckoutEvent } from '../../Services/Tracking.service';
import OrderRowProductCardB2B from '../OrderRowProductCard/OrderRowProductCardB2B';
import useIsStoreScreen from '../../Hooks/useIsStoreScreen';

const Cart = () => {
  const dispatch = useDispatch();
  const cart = useTypedSelector((state) => state.cart);
  const [cartItemsVisible, setCartItemsVisible] = useState(false);
  const hasOrderRows =
    cart.orderRows && Object.keys(cart.orderRows).length > 0;
  const removeRow = (row: OrderRow) => {
    dispatch(update(row.rowSystemId, 0));
  };

  const { current } = useTypedSelector((state) => state.userInfo);
  const isStoreScreen = useIsStoreScreen();

  useEffect(() => {
    if (cart) {
      trackingServiceInitiateCheckoutEvent(cart);
    }
  }, []);

  return (
    <>
      <div className="mx-auto mb-6 w-full bg-white lg:max-w-[660px] lg:rounded">
        <div
          onClick={() => setCartItemsVisible(!cartItemsVisible)}
          className="flex flex-1 cursor-pointer flex-row items-center justify-between px-6 pb-5 pt-6"
        >
          <h3 className="text-h3">
            {translate('checkout.cart.title') + ' (' + cart.quantity + ')'}
          </h3>
          <Icon
            name="chevron-left"
            className={clsx(
              'h-4 w-4 transition-transform',
              cartItemsVisible ? 'rotate-90' : 'rotate-[270deg] '
            )}
          />
        </div>
        <div
          className={clsx(
            'grid transition-[grid-template-rows] duration-200',
            cartItemsVisible ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
          )}
        >
          <div className="overflow-hidden">
            {(current?.isBusinessCustomer || isStoreScreen) && hasOrderRows
              ? Object.values(cart.orderRows).map((row: any) => (
                  <OrderRowProductCardB2B
                    className={clsx(
                      'mb-5 px-4 lg:px-6 [&:last-child]:mb-0 [&:last-child_>div]:border-b-0'
                    )}
                    key={row.rowSystemId}
                    row={row}
                    onRemoveClick={() => removeRow(row)}
                  />
                ))
              : Object.values(cart.orderRows).map((row: any) => (
                  <OrderRowProductCard
                    className={clsx(
                      'mb-5 px-4 lg:px-6 [&:last-child]:mb-0 [&:last-child_>div]:border-b-0'
                    )}
                    key={row.rowSystemId}
                    row={row}
                    onRemoveClick={() => removeRow(row)}
                  />
                ))}
          </div>
        </div>
        <hr className="border-gray-100" />
        <div className="p-6">
          <Discount />
          <CheckoutOrderSummary />
        </div>
      </div>
    </>
  );
};

export default Cart;
